import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b12a24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }
const _hoisted_2 = { class: "card main-table-container card-primary card-outline" }
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Usuarios")
], -1))
const _hoisted_7 = { class: "card-body p-0" }
const _hoisted_8 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-sort": "ascending",
      "aria-label": "Rendering engine: activate to sort column descending"
    }, " Nombre "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Browser: activate to sort column ascending"
    }, " Correo electronico "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Platform(s): activate to sort column ascending"
    })
  ])
], -1))
const _hoisted_13 = { class: "position-relative" }
const _hoisted_14 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-6 col-md-4 px-4" }
const _hoisted_19 = { class: "rol-select" }
const _hoisted_20 = { class: "form-group col-md-12" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Roles", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "SELECCIONA UN ROL", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "card mt-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Roles seleccionados")
], -1))
const _hoisted_28 = { class: "card-body p-0" }
const _hoisted_29 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-12" }
const _hoisted_32 = { class: "table-responsive" }
const _hoisted_33 = {
  key: 0,
  class: "position-absolute overlay w-100 h-100 mx-auto"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-sort": "ascending",
      "aria-label": "Rendering engine: activate to sort column descending"
    }, " Nombre "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Platform(s): activate to sort column ascending"
    })
  ])
], -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "100%"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "card-footer text-center" }

export function render(_ctx, _cache) {
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isBtnLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "odd",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_14, _toDisplayString(user.name), 1),
                      _createElementVNode("td", null, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          disabled: "!editMode",
                          value: user.id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedUsers) = $event)),
                          onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.uniqueCheck && _ctx.uniqueCheck(...args)))
                        }, null, 40, _hoisted_16), [
                          [_vModelCheckbox, _ctx.selectedUsers]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_pagination, {
              modelValue: _ctx.page,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.page) = $event)),
              records: _ctx.records,
              "per-page": _ctx.perPage,
              onPaginate: _ctx.getResults
            }, null, 8, ["modelValue", "records", "per-page", "onPaginate"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.role) = $event))
            }, [
              _hoisted_22,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: index
                }, _toDisplayString(item.name), 9, _hoisted_23))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.role]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success add-rol-btn ml-2",
            onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.addRole && _ctx.addRole(...args)))
          }, _hoisted_25)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                    : _createCommentVNode("", true),
                  _createElementVNode("table", _hoisted_36, [
                    _hoisted_37,
                    (_ctx.selectedRoles && _ctx.selectedRoles.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRoles, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              class: "odd",
                              key: index
                            }, [
                              _createElementVNode("td", _hoisted_39, _toDisplayString(item.name), 1),
                              _createElementVNode("td", _hoisted_40, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger ml-2",
                                  onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.removeRole && _ctx.removeRole(...args)))
                                }, _hoisted_42)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success",
          onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.saveAsociation && _ctx.saveAsociation(...args)))
        }, " Guardar "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger ml-3",
          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.goToUsersList && _ctx.goToUsersList(...args)))
        }, " Cancelar ")
      ])
    ])
  ]))
}